export default {
  cvdatas:{
    listSuccess:{
      workplace: 'Environnement de travail',
      conditions: 'Conditions de travail',
      teamwork: 'Relations professionnelles',
      office: 'Aménagements de poste',
    },
    success:{
      workplace :{ 
        'Lieu de travail' : ['Open space', 'Bureau partagé', 'Bureau seul'],
        'Type de bureau' : ['Bureau fixe', 'Flex office', 'Hybride (fixe + flex)'],
        'Organisation de travail': ['Uniquement en présentiel', 'Télétravail complet (full remote)', 'Télétravail partiel']
      },
      conditions:{ 
        'Horaires': ['Horaires fixes', 'Horaires variables', 'Horaires adaptées'],
        'Temps de travail':['Temps partiel', 'Temps plein'],
        'Rythme de travail': ['Rythme soutenu', 'Rythme régulier', 'Rythme alterné'],
        'Types d\'activités': ['Activités variées', 'Activités répétitives', 'Activités ordonnées', 'Activités planifiées', 'Activités simples']
      },
      teamwork: {
        'Lien au travail': ['Travaille seul', 'Travaille en équipe'],
        'Diffusion d\'informations': ['Informations à l\'écrit', 'Informations à l\'oral', 'Informations à l\'écrit et à l\'oral'],
        'Organisation des réunions': ['Réunions planifiées', 'Réunions avec supports écrits', 'Place adaptée en réunion']
      },
      office: {
        'Ergonomie du poste de travail': ['oui', 'non'],
        'Adaptation du temps de travail': ['oui', 'non'],
        'Adaptation des horaires de travail': ['oui', 'non'],
      },
    },
    atouts:[
      /* "Adaptabilité", */ /* "Altruisme", */ 'Ambition', 'Anticipation', 'Appartenance',
      'Assurance', 'Audace', 'Auto-discipline', 'Autonomie', 'Bienveillance',
      'Bravoure', 'Calme', 'Camaraderie', /* "Certitude", */
      'Compréhension', 'Concentration', 'Confiance en soi', /* "Conformité", */ /* "Conscience", */
      /* "Contentement", */ 'Contribution', 'Contrôle', 'Conviction', 'Convivialité',
      'Coopération', /* "Cordialité", */ /* "Courage", */ 'Courtoisie', 'Créativité',
      'Curiosité', 'Découverte', 'Défi', 'Détermination', /* "Discernement", */
      'Discipline', 'Discrétion', 'Diversité', 'Dynamisme', 'Efficacité',
      'Égalité', 'Empathie', 'Endurance', 'Énergie', 'Engagement',
      'Enthousiasme', /* "Excellence", */ 'Extravagance', /* "Fiabilité", */ 'Fidélité',
      'Flexibilité', 'Franchise', 'Générosité', 'Gratitude', 'Honnêteté',
      /* "Intelligence", */ 'Intrépide', 'Joie', 'Liberté', 'Indépendance',
      'Partage', 'Performance', 'Politesse', 'Prise de décision', 'Réflexion',
      /* "Résilience", */ 'Respect', 'Retenue', 'Rigueur', 'Sagesse',
      'Sang-froid', 'Sérénité', 'Simplicité', 'Solidarité', 'Solitude',
      'Spontanéité', 'Tradition', 'Travail d\'équipe', /* "Unité", */ 'Vigilance',
      'Accomplissement', /* "Argent", */ 'Authenticité', 'Aventure', 'Bien-être', 
      'Changement', 'Compétition', 'Dépassement de soi', 'Expertise', 'Harmonie', 
      'Humour', 'Intégrité', 'Loyauté', 'Relationnel', 'Responsabilité', 
      'Tolérance', 'Variété',
    ],
    needs:[
      'De relever des défis', 'D\'être rassuré', 'D\'être encouragé',  'Des projets à court terme',  'Des projets à long terme',
      'De calme', 'De soutien du groupe', 'D\'être indépendant', 'De reconnaissance financière', 'De sécurité',
      'De résultats quantifiables', 'D\'atteindre des buts précis', 'De satisfaction personnelle', 'De trouver des solutions', 'De prendre des initiatives', 
      'De conduire des projets', 'D\'anticipation', 'D\'appartenance à un groupe', 'De confiance du groupe', 'De changements', 
      'De développer mes compétences', 'D\'être reconnu en tant qu\'expert', 'D\'être reconnu dans un domaine précis', 'D\'être cadré avec des tâches précises', 'D\'être cadré avec des objectifs précis',
      'De travailler selon un planning strict', 'De travailler selon des procédures',
    ],
    /* level_formations:{
            'Niveau I - (Diplômes universitaires nationaux de Troisième cycle universitaire : DEA, DESS, DHET, Doctorat)': 'Niveau 1',
            'Niveau II - (Diplômes universitaires nationaux de second cycle : licence ou maîtrise)': 'Niveau 2',
            'Niveau III - (BTS, DUT, DEUST...)': 'Niveau 3',
            'Niveau IV - (Baccalauréats, Brevet de Technicien...)': 'Niveau 4',
            'Niveau V - (CAP, BEP...)': 'Niveau 5',
            'Niveau V bis - (CFG, DNB - anciennement BEPC)': 'Niveau 5',
            'Niveau VI - (Scolarité obligatoire)': 'Niveau 6',
            'Autres': '',
        } */

    level_formations:{
      'Aucun': '',
      'Niveau 3 - CAP, BEP': 'Niveau 3',
      'Niveau 4 - Baccalauréat': 'Niveau 4',
      'Niveau 5 - DEUG, BTS, DUT, DEUST': 'Niveau 5',
      'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1': 'Niveau 6',
      'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur': 'Niveau 7',
      'Niveau 8 - Doctorat, habilitation à diriger des recherches': 'Niveau 8',
      'Autre': '',
    }


  }
};